export const popoverSx = {
  '.MuiPaper-root.MuiPopover-paper': {
    borderRadius: '16px',
    background: 'rgba(255, 255, 255, 0.7)',
    backdropFilter: 'blur(10px)',
  },
};
